export const DDMMYYYY = "DD-MM-YYYY";
export const MMDDYYYY = "MM-DD-YYYY";